import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";

const getFloorsByFirebaseId = createSelector([
  getDomain
], (domain) => domain.floors.byFirebaseId);

export default getFloorsByFirebaseId;
